import React, { Component } from 'react';
import MaterialTable from 'material-table';
import firebase from '../../firebase'
import CircularProgress from "@material-ui/core/CircularProgress";

import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
// import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';



// import Add from '@material-ui/icons/Add'





import Delete from '@material-ui/icons/Delete'

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <Delete {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};



class OffersTable extends Component{

    constructor(props) {
        super(props)

        this.state = {
            columns: [
                {
                    title: 'Code',
                    field: 'code',
                    sorting: false,
                    required: true
                },
                {
                    title: 'Image',
                    field: 'imageUrl',
                    maxWidth: 100,
                    sorting: false,
                    render: rowData => rowData.imageUrl ? <img src={rowData.imageUrl} alt="Promo" width="70" height="50"/> : <></>,
                    cellStyle: {
                        maxWidth: 50
                    },
                },
                {
                    title: 'Description',
                    field: 'message',
                    sorting: false,
                },
                {
                    title: 'Discount (%)',
                    field: 'discount',
                    type: 'numeric',
                    sorting: false,
                },
                {
                    title: 'Max Discount (Rs)',
                    field: 'max',
                    type: 'numeric',
                    sorting: false,
                },
                {
                    title: 'Min Cart (Rs)',
                    field: 'minCart',
                    type: 'numeric',
                    sorting: false,
                },
                {
                    title: 'Type',
                    field: 'type',
                    lookup: { 0: 'Promotion', 1: 'Coupon', 2: 'Image' },
                    required: true,
                    sorting: false,
                },
            ],
            data: [],
            loading: true
        }

        this.database = firebase.database().ref().child('offers')

    }

    componentDidMount() {

        // var prevOffers = this.state.offers
        this.database.on('child_added', snap => {
            this.setState((prevState) => {
                const data = [...prevState.data];
                var offer = snap.val()
                offer.key = snap.key
                data.push(offer);
                return { ...prevState, data, loading: false };
            });
        })

        this.database.on('child_removed', snap => {
            this.setState((prevState) => {
                const data = [...prevState.data];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].key === snap.key) {
                        data.splice(i, 1);
                        break;
                    }
                }
                return { ...prevState, data };
            });

        })

        this.database.on('child_changed', snap => {
            this.setState((prevState) => {
                const data = [...prevState.data];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].key === snap.key) {
                        var offer = snap.val()
                        offer.key = snap.key
                        data.splice(i, 1, offer);
                        break;
                    }
                }
                return { ...prevState, data };
            });
            this.forceUpdate()
        })

    }

    updateOffer = async (newOffer, oldOffer) => {
        this.database.child(newOffer.key).update(newOffer)
    }

    deleteOffer = (offer) => {
        this.database.child(offer.key).remove().then(
            console.log("successfully deleted")
        ).catch(
            console.log("error in deleting")
        )
    }

    addOffer = async (offer) => {
        console.log(offer)
        this.database.push(offer)
    }

    render() {
        const { columns, data, loading } = this.state  
        console.log(data)
        return (
            loading ? < CircularProgress style={{ position: "fixed", top: "50%", left: "50%" }}></CircularProgress> :
            <MaterialTable
                title="Offers and Promotions"
                columns={columns}
                data={data}
                icons={tableIcons}
                editable={{
                    onRowAdd: (newData) =>
                        new Promise((resolve) => {
                            this.addOffer(newData)
                            setTimeout(() => {
                                resolve();
                                // this.setState((prevState) => {
                                //     const data = [...prevState.data];
                                //     data.push(newData);
                                //     return { ...prevState, data };
                                // });
                            }, 600);
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                            this.updateOffer(newData, oldData)
                            setTimeout(() => {
                                resolve();
                                // if (oldData) {
                                //     this.setState((prevState) => {
                                //         const data = [...prevState.data];
                                //         // data[data.indexOf(oldData)] = newData;
                                //         data.splice(data.indexOf(oldData), 1);
                                //         return { ...prevState, data };
                                //     });
                                // }
                            }, 600);
                        }),
                    onRowDelete: (oldData) =>
                        new Promise((resolve) => {
                            this.deleteOffer(oldData)
                            setTimeout(() => {
                                resolve();
                                // this.setState((prevState) => {
                                //     const data = [...prevState.data];
                                //     data.splice(data.indexOf(oldData), 1);
                                //     return { ...prevState, data };
                                // });
                            }, 600);
                        }),
                }}
            />
        )
    }
}

export default OffersTable